'use client';

import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { OptionHorizontalIcon } from '@/icons';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui';
import { Button, Drawer, DrawerContent, DrawerTrigger, IconButton } from '@/ui_v3';
import { useConfirmPersistData, usePersistButtonVisible } from '../hook/useConfirmPersistData';
export const ContinueOnPersistBuildButton = () => {
  const {
    handleConfirmPersistData,
    persistData
  } = useConfirmPersistData();
  const isPersistButtonVisible = usePersistButtonVisible();
  const {
    t
  } = useTranslation(['build']);
  const {
    isTablet,
    isMobile
  } = useViewport();
  if (!isPersistButtonVisible) return <></>;
  if (isTablet) return <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconButton variant={'outlined'} intent={'neutral'} size="md">
            <OptionHorizontalIcon size="md" />
          </IconButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem className="w-[180px] text-body-sm-medium" onClick={() => handleConfirmPersistData(persistData)}>
            {t('build:continueWriting')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>;
  if (isMobile) return <Drawer>
        <DrawerTrigger asChild>
          <IconButton variant={'outlined'} intent={'neutral'} size="md">
            <OptionHorizontalIcon size="md" />
          </IconButton>
        </DrawerTrigger>
        <DrawerContent className="w-full" hasDrawerHandle hasDim>
          <div className="p-md pb-lg text-body-lg-medium" onClick={() => handleConfirmPersistData(persistData)}>
            {t('build:continueWriting')}
          </div>
        </DrawerContent>
      </Drawer>;
  return <Button size={'md'} variant={'outlined'} intent={'neutral'} onClick={() => handleConfirmPersistData(persistData)} data-sentry-element="Button" data-sentry-component="ContinueOnPersistBuildButton" data-sentry-source-file="ContinueOnPersistBuildButton.tsx">
      {t('build.autoSave.writeNext')}
    </Button>;
};